module.exports = __webpack_public_path__ + "static/media/sample.3a43b5e4.png";